import useSWR from 'swr'

import {ItemType} from '../types'
import {getItemTypes} from '../api/itemApi'

export default function useItemTypes() {
  return useSWR<ItemType[], Error>('item-types', getItemTypes)
}
